import classNames from 'classnames';
import Typography from 'components/generics/texts/Typography';
import { motion } from 'framer-motion';
import React, { HTMLAttributes, useEffect, useState } from 'react';
import classes from './index.module.scss';

export type ToggleItem = {
  label?: string;
  value: string;
};

export interface AnimatedToggleProps extends HTMLAttributes<HTMLDivElement> {
  items: ToggleItem[];
  onChangeValue?: (value: string) => void;
  itemClassName?: string;
  activeItemClassName?: string;
  switcherClassName?: string;
  disabled?: boolean;
  value?: string;
  onGlobalClick?: () => void;
}

const AnimatedToggle = ({
  disabled,
  items,
  onChangeValue,
  itemClassName,
  activeItemClassName,
  switcherClassName,
  className,
  value,
  onGlobalClick,
}: AnimatedToggleProps) => {
  const [currentValue, setCurrentValue] = useState(value || items[0].value);
  const onClick = (value: string) => {
    setCurrentValue(value);
    onChangeValue && onChangeValue(value);
  };

  useEffect(() => {
    value !== undefined && setCurrentValue(value);
  }, [value]);

  return (
    <div
      className={classNames(classes.container, className)}
      onClick={onGlobalClick}
    >
      {items.map((item) => {
        return (
          <div
            onClick={() => !onGlobalClick && !disabled && onClick(item.value)}
            key={item.value}
            className={classNames(
              classes.gridItem,
              disabled && classes.disabled,
              itemClassName,
              item.value === currentValue && classes.active,
              item.value === currentValue && activeItemClassName
            )}
          >
            {item.value === currentValue && (
              <motion.div
                className={classNames(classes.switcher, switcherClassName)}
                layoutId="active"
                transition={{
                  type: 'spring',
                  stiffness: 1000,
                  damping: 80,
                }}
              />
            )}
            <Typography className={classes.text}>{item?.label}</Typography>
          </div>
        );
      })}
    </div>
  );
};
export default AnimatedToggle;
